.play {
  flex: none;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--mantine-color-brand-5);
  color: var(--mantine-color-white);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--mantine-shadow-xs);
}

.toggle {
  display: inline-flex;
  align-items: center;
  gap: var(--mantine-spacing-xxxs);
}

.quote {
  padding-left: var(--mantine-spacing-sm);
  border-left: 2px solid var(--mantine-color-gray-2);
}
